import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../context/Provider';

/**
 * Coloca en nombre de la ventana y de igual manera esto depende del tipo de skin que tenga
 * @param webPageName string
 * @returns string
 */
export const UseChangeWebPageTitle = (webPageName: string) => {
    const { activeSkinConfig } = useContext(AppContext);
    const [nameOfWebPage, setNameOfWebPage] = useState('');

    useEffect(() => {
        const webPageTitle = webPageName + activeSkinConfig.name;

        const faviconRoute = activeSkinConfig.iconPath;

        document.title = webPageTitle;
        document.getElementById('favicon')?.setAttribute('href', faviconRoute);
        setNameOfWebPage(webPageTitle);
    }, [webPageName]);

    return { nameOfWebPage };
};
